import { createSlice } from "@reduxjs/toolkit";
import { API_STATUS } from "../../../constants/apiStatus";
import {
  getUserProfileAction,
  updateUserProfileAction,
  uploadAvatarAction,
} from "./userProfileSliceActions";
import { userProfileSliceInitialState } from "./userProfileSliceInitialState";

const initialState = userProfileSliceInitialState;

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    updateProfileField: (state, action) => {
      if (state.profile) {
        state.profile[action.payload.field] = action.payload.value;
      }
    },
    resetUserProfileState: () => initialState,
  },
  extraReducers: (builder) => {
    // Get User Profile
    builder.addCase(getUserProfileAction.fulfilled, (state, action) => {
      state.apiStatus.getProfile = API_STATUS.COMPLETED;
      state.profile = action.payload.userProfile || action.payload;
      state.error = null;
    });
    builder.addCase(getUserProfileAction.pending, (state) => {
      state.apiStatus.getProfile = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(getUserProfileAction.rejected, (state, action) => {
      state.apiStatus.getProfile = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Update User Profile
    builder.addCase(updateUserProfileAction.fulfilled, (state, action) => {
      state.apiStatus.updateProfile = API_STATUS.COMPLETED;
      state.profile = action.payload;
      state.error = null;
    });
    builder.addCase(updateUserProfileAction.pending, (state) => {
      state.apiStatus.updateProfile = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(updateUserProfileAction.rejected, (state, action) => {
      state.apiStatus.updateProfile = API_STATUS.FAILED;
      state.error = action.payload;
    });

    // Upload Avatar
    builder.addCase(uploadAvatarAction.fulfilled, (state, action) => {
      state.apiStatus.uploadAvatar = API_STATUS.COMPLETED;
      if (state.profile) {
        state.profile.avatar = action.payload.avatarUrl;
      }
      state.error = null;
    });
    builder.addCase(uploadAvatarAction.pending, (state) => {
      state.apiStatus.uploadAvatar = API_STATUS.STARTED;
      state.error = null;
    });
    builder.addCase(uploadAvatarAction.rejected, (state, action) => {
      state.apiStatus.uploadAvatar = API_STATUS.FAILED;
      state.error = action.payload;
    });
  },
});

export const { clearError, updateProfileField, resetUserProfileState } =
  userProfileSlice.actions;

export default userProfileSlice.reducer;
